import React from 'react'
import {
  Header,
  PATHS,
  TRANSLATIONS,
  media,
  multiMedia,
  useTranslations
} from 'fractals'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import { SEO_DESCRIPTION, SEO_TITLE, TJournalPageProps } from './fractals'
import { BreadcrumbsReact, PageContainer } from '../shared/widgets'
import { Shared } from '../shared'
import { Main, Spinner } from '@/fractals/components'
import { RelatedCoursesMobile } from './widgets/Journal/fractals/components/molecules'
import { DownloadFreeMobile } from './widgets/Journal/fractals/components/atoms'

const DynamicJournal = dynamic(() => import('./widgets/Journal/Journal'), {
  loading: () => <Spinner />
})

export const JournalPage = ({
  bread,
  journal,
  seoJournal,
  footer
}: TJournalPageProps) => {
  const { asPath } = useRouter()

  const [companyName, defaultSeoTitle, defaultSeoDescription] = useTranslations(
    TRANSLATIONS.companyName,
    SEO_TITLE,
    SEO_DESCRIPTION
  )

  const seoParams = {
    title: seoJournal?.seo.metaTitle || defaultSeoTitle || null,
    desc: seoJournal?.seo.metaDescription || defaultSeoDescription || null,
    canonical:
      seoJournal?.seo.canonicalURL || `${PATHS.front.root.index}${asPath}`
  }

  return (
    <>
      <NextSeo
        title={seoParams.title || undefined}
        description={seoParams.desc || undefined}
        canonical={seoParams.canonical}
        openGraph={{
          url: seoParams.canonical,
          title: seoParams.title || undefined,
          description: seoParams.desc || undefined,
          images: [
            {
              url: `${PATHS.front.root.index}${PATHS.front.public.assets.imgs.icons.mitmLogo512.index}`,
              width: 512,
              height: 512,
              alt: companyName,
              type: 'image/png'
            }
          ],
          site_name: companyName
        }}
      />
      <PageContainer>
        <>
          {journal?.programs && (
            <RelatedCoursesMobile programs={journal?.programs} />
          )}
          {journal?.pdf && (
            <DownloadFreeMobile
              pdf={journal?.pdf}
              category={journal?.category}
              programs={journal?.programs}
            />
          )}
        </>
        <Header
          styles={{
            '& > div': {
              ...media('maxWidth', null, {
                laptop: '800px',
                tablet: '640px',
                phone: '343px'
              })
            },
            'div > div': {
              gap: '40px'
            }
          }}
          variant='beta'>
          <BreadcrumbsReact bread={bread} />
        </Header>
        <Main>
          <DynamicJournal key='Journal__id' journal={journal} />
          {/* <Shared.AskModal
            styles={{
              ...multiMedia({
                desktop: { bottom: '25px' },
                laptop: { bottom: '25px' },
                tablet: { bottom: '100px' },
                phone: { bottom: '100px' }
              })
            }}
          /> */}
        </Main>
        <Shared.Footer footer={footer} />
      </PageContainer>
    </>
  )
}

export default JournalPage
